import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import ContextStates from '../context/ContextStates';
import { motion } from 'framer-motion';
import { areaAnimateLR, areaAnimateS, areaAnimateRL, areaAnimateDU } from './Animations';
import 'swiper/css/bundle';
import { Url } from './Url';
import { Link } from 'react-router-dom';


const GetCatProductos = () => {
    const [categorias, setCategorias] = useState([]);
    const { setProductos, modify } = useContext(ContextStates)

    useEffect(() => {
        const query = async () => {
            const url = `${Url}api/getCatProductos.php`;
            const resultado = await axios.get(url);
            setCategorias(resultado.data.results);
            //console.log(resultado)
        }
        query();
    }, [])

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append('id', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listadoproductos.php',
                    method: 'POST',
                    data: formData,
                })
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify])


    return (
        <div className='w-full'>
            {categorias && categorias.map((item, index) => (
                <div key={index}
                >
                    <motion.h2
                        className='bg-orange-600 p-4 text-3xl mt-20 mb-10 text-white font-bold text-center'
                        initial={"offscreen"}
                        whileInView={"onscreen"}
                        viewport={{ once: true, amount: 0.1 }}
                        variants={areaAnimateS}
                        whileHover={{
                            //scale: 1.1,
                            //transition: { duration: 1 },
                        }}
                    >{item.descripcion}</motion.h2>
                    <motion.div className={`w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4`}
                    >
                        {item.productos && item.productos.map((item, index) => (
                            <motion.div
                                key={index}
                                className='w-11/12 md:10/12 mx-auto shadow-2xl hover:shadow-3xl rounded-2xl'
                                initial={"offscreen"}
                                whileInView={"onscreen"}
                                viewport={{ once: true, amount: 0.1 }}
                                variants={areaAnimateS}
                                whileHover={{
                                }}
                            >
                                <Link className='w-full mx-2 shadow-2xl hover:shadow-3xl rounded-2xl' to={`/producto/${item.idproducto}`}>

                                    <div className='hover:cursor-pointer'>
                                        <img className='w-full object-cover rounded-2xl' src={Url + item.imagen} alt={item.descripcion} />
                                        <h3 className='text-center text-xl mt-4 mb-2'>{item.descripcion}</h3>
                                        <h3 className='text-center text-2xl mt-2 mb-2'>$ {parseFloat(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</h3>

                                    </div>
                                </Link>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            ))}
        </div>
    );
}

export default GetCatProductos